import { useEffect } from "react";
import UserProfile from "../../../features/user/UserProfile";
import Dashboard from "../Dashboard";

const Profile = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <Dashboard>
      <UserProfile />
    </Dashboard>
  );
};

export default Profile;
